import * as React from 'react';
import { connect } from 'react-redux';
import * as queryString from 'query-string';

import FirstPageForm from '../FirstPageForm/FirstPageForm';
import * as FindUserCreators from '../../creators/findUser';
import * as FindUserActions from '../../actions/findUser';
import * as DatepickerActions from '../../actions/datepickers';
import * as ProductActions from '../../actions/product';

import './style.scss';

interface DispatchProps {
  findUser: () => void;
  fetchFindUserEmailAction: (email: string) => void;
  fetchFindUserAuthIdAction: (email: string) => void;
  fetchDatepickersStart: (date: number) => void;
  fetchDatepickersEnd: (date: number) => void;
  fetchReceiveProduct: (product: number) => void;
}

interface OwnProps {
  location: Location;
}

interface Props extends DispatchProps, OwnProps {}

const Home = (props: Props) => {

  const [id, setId] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [fromDate, setFromDate] = React.useState('');
  const [toDate, setToDate] = React.useState('');
  const [product, setProduct] = React.useState('');

  const {
    fetchFindUserEmailAction,
    fetchFindUserAuthIdAction,
    fetchDatepickersEnd,
    fetchDatepickersStart,
    fetchReceiveProduct,
    findUser,
    location,
  } = props;

  React.useEffect(() => {
    const values = queryString.parse(location.search) as Record<string, any>;

    if (values.product) {
      setProduct(values.product);
      fetchReceiveProduct(Number(product));
    }
    if (values.from) {
      setFromDate(values.from);
      fetchDatepickersStart(Date.parse(values.from));
    }
    if (values.to) {
      setToDate(values.to);
      fetchDatepickersEnd(Date.parse(values.to));
    }
    if (values.id) {
      setId(values.id);
      fetchFindUserAuthIdAction(id);
      findUser();
    }
    if (values.email) {
      setEmail(values.email);
      fetchFindUserEmailAction(email);
      findUser();
    }

  }, [id, email, fromDate, product, toDate, fromDate]);

  return (
    <main className='home'>
      <FirstPageForm />
    </main>
  );
};

const mapStateToProps = () => {
  return {};
};

const mergeProps = (stateProps, dispatchProps: DispatchProps, props: OwnProps): Props => {
  return {
    ...stateProps,
    findUser: dispatchProps.findUser,
    fetchFindUserEmailAction: dispatchProps.fetchFindUserEmailAction,
    fetchFindUserAuthIdAction: dispatchProps.fetchFindUserAuthIdAction,
    fetchDatepickersStart: dispatchProps.fetchDatepickersStart,
    fetchDatepickersEnd: dispatchProps.fetchDatepickersEnd,
    fetchReceiveProduct: dispatchProps.fetchReceiveProduct,
    ...props,
  };
};

export default connect(
  mapStateToProps, {
    findUser: FindUserCreators.findUser,
    fetchFindUserEmailAction: FindUserActions.fetchFindUserEmailAction,
    fetchFindUserAuthIdAction: FindUserActions.fetchFindUserAuthIdAction,
    fetchDatepickersStart: DatepickerActions.fetchDatepickersStartAction,
    fetchDatepickersEnd: DatepickerActions.fetchDatepickersEndAction,
    fetchReceiveProduct: ProductActions.fetchReceiveProductAction,
  }, mergeProps
)(React.memo(Home));
